"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.db = exports.FINAL_ROOM_STATE = exports.RoomStateOrder = exports.RoomState = exports.RoomEventTypes = exports.VoteTypes = exports.PUBLIC_USER_KEYS = void 0;
exports.PUBLIC_USER_KEYS = ['id', 'username'];
var VoteTypes;
(function (VoteTypes) {
    VoteTypes["LIKE"] = "LIKE";
    VoteTypes["DISLIKE"] = "DISLIKE";
    VoteTypes["PASS"] = "PASS";
})(VoteTypes = exports.VoteTypes || (exports.VoteTypes = {}));
var RoomEventTypes;
(function (RoomEventTypes) {
    RoomEventTypes["USER_READY_CHANGED"] = "USER_READY_CHANGED";
    RoomEventTypes["ROOM_STATE_CHANGED"] = "ROOM_STATE_CHANGED";
    RoomEventTypes["ROOM_JOINED"] = "ROOM_JOINED";
    RoomEventTypes["ROOM_LEFT"] = "ROOM_LEFT";
    RoomEventTypes["MOVIE_VOTE"] = "MOVIE_VOTE";
    RoomEventTypes["MOVIES_RETRIEVED"] = "MOVIES_RETRIEVED";
    RoomEventTypes["RESULTS_COMPUTED"] = "RESULTS_COMPUTED";
})(RoomEventTypes = exports.RoomEventTypes || (exports.RoomEventTypes = {}));
var RoomState;
(function (RoomState) {
    RoomState["ACTIVE"] = "ACTIVE";
    RoomState["MOVIE_PREF"] = "MOVIE_PREF";
    RoomState["MOVIE_VOTING"] = "MOVIE_VOTING";
    RoomState["RESULTS"] = "RESULTS";
    RoomState["INACTIVE"] = "INACTIVE";
})(RoomState = exports.RoomState || (exports.RoomState = {}));
exports.RoomStateOrder = [
    RoomState.ACTIVE,
    RoomState.MOVIE_PREF,
    RoomState.MOVIE_VOTING,
    RoomState.RESULTS,
    RoomState.INACTIVE,
];
exports.FINAL_ROOM_STATE = exports.RoomStateOrder[exports.RoomStateOrder.length - 1];
const val = (path) => ({ val: (val) => ({ [path]: val }) });
const valObj = (path) => (val) => ({ [path]: val });
const push = (path) => (ref) => (val) => __awaiter(void 0, void 0, void 0, function* () {
    const roomRef = ref.child(path).push();
    yield roomRef.set(Object.assign({ id: roomRef.key }, val));
    return roomRef;
});
exports.db = (Object.assign(Object.assign({}, val('/')), { rooms: (() => {
        const roomsUpdater = (roomId) => (Object.assign(Object.assign({}, val(`rooms/${roomId}`)), { id: val(`rooms/${roomId}/id`), state: val(`rooms/${roomId}/state`), admin: (Object.assign(Object.assign({}, val(`rooms/${roomId}/admin`)), { id: val(`rooms/${roomId}/admin/id`), username: val(`rooms/${roomId}/admin/username`) })), connectedUsers: val(`rooms/${roomId}/connectedUsers`), readyUsers: (() => {
                const readyUsersUpdater = (userId) => (Object.assign({}, val(`rooms/${roomId}/readyUsers/${userId}`)));
                readyUsersUpdater.val = valObj(`rooms/${roomId}/readyUsers`);
                return readyUsersUpdater;
            })(), roomKey: val(`rooms/${roomId}/roomKey`), providerIds: val(`rooms/${roomId}/providerIds`), preferences: (() => {
                const preferencesUpdater = (userId) => (Object.assign(Object.assign({}, val(`rooms/${roomId}/preferences/${userId}`)), { genreVotes: (() => {
                        const genreVotesUpdater = (genreId) => (Object.assign({}, val(`rooms/${roomId}/preferences/${userId}/genreVotes/${genreId}`)));
                        genreVotesUpdater.val = valObj(`rooms/${roomId}/preferences/${userId}/genreVotes`);
                        return genreVotesUpdater;
                    })(), suggestion: val(`rooms/${roomId}/preferences/${userId}/suggestion`) }));
                preferencesUpdater.val = valObj(`rooms/${roomId}/preferences`);
                return preferencesUpdater;
            })(), movies: val(`rooms/${roomId}/movies`), votes: (() => {
                const votesUpdater = (voteId) => (Object.assign(Object.assign({}, val(`rooms/${roomId}/votes/${voteId}`)), { id: val(`rooms/${roomId}/votes/${voteId}/id`), uid: val(`rooms/${roomId}/votes/${voteId}/uid`), tmdbID: val(`rooms/${roomId}/votes/${voteId}/tmdbID`), voteType: val(`rooms/${roomId}/votes/${voteId}/voteType`) }));
                votesUpdater.val = valObj(`rooms/${roomId}/votes`);
                votesUpdater.push = push(`rooms/${roomId}/votes`);
                return votesUpdater;
            })(), results: (Object.assign(Object.assign({}, val(`rooms/${roomId}/results`)), { voteResult: val(`rooms/${roomId}/results/voteResult`), userResult: (Object.assign(Object.assign({}, val(`rooms/${roomId}/results/userResult`)), { likedMostMovies: val(`rooms/${roomId}/results/userResult/likedMostMovies`), dislikedMostMovies: val(`rooms/${roomId}/results/userResult/dislikedMostMovies`), userLikenessMap: val(`rooms/${roomId}/results/userResult/userLikenessMap`) })) })) }));
        roomsUpdater.val = valObj('rooms');
        roomsUpdater.push = push('rooms');
        return roomsUpdater;
    })(), users: (() => {
        const userUpdater = (uid) => (Object.assign(Object.assign({}, val(`users/${uid}`)), { id: val(`users/${uid}/id`), username: val(`users/${uid}/username`), recentRoomID: val(`users/${uid}/recentRoomID`), preferences: (Object.assign(Object.assign({}, val(`users/${uid}/preferences`)), { providerIds: val(`users/${uid}/preferences/providerIds`) })) }));
        userUpdater.val = valObj(`users`);
        return userUpdater;
    })(), roomEvents: (() => {
        const roomEventsUpdater = (roomEventId) => (Object.assign(Object.assign({}, val(`room_events/${roomEventId}`)), { id: val(`room_events/${roomEventId}/id`), roomID: val(`room_events/${roomEventId}/roomID`), uid: val(`room_events/${roomEventId}/uid`), createdAt: val(`room_events/${roomEventId}/createdAt`), eventType: val(`room_events/${roomEventId}/eventType`), eventData: val(`room_events/${roomEventId}/eventData`) }));
        roomEventsUpdater.val = valObj('room_events');
        roomEventsUpdater.push = push('room_events');
        return roomEventsUpdater;
    })() }));
//# sourceMappingURL=index.js.map